import { useTitle } from "react-use";

import { CommandMenu, CommandMenuProvider } from "@/components/CommandMenu";
import { SubHeader } from "@/components/SubHeader";
import { Breadcrumb, Breadcrumbs } from "@/components/ui/breadcrumbs";
import { ViewProvider } from "@/features/view/components/ViewProvider";
import { AccessionDisplay } from "../components/AccessionDisplay";
import {
  AccessionDisplayPopover,
  AccessionFilterPopover,
  FilterBar,
} from "../components/AccessionFilters";

export const AccessionPage = () => {
  useTitle("Accessions");

  return (
    <ViewProvider>
      <SubHeader>
        <SubHeader.Left>
          <Breadcrumbs>
            <Breadcrumb>Accessions</Breadcrumb>
          </Breadcrumbs>
        </SubHeader.Left>
        <SubHeader.Right className="gap-2">
          <AccessionFilterPopover />
          <AccessionDisplayPopover />
        </SubHeader.Right>
      </SubHeader>
      <FilterBar />
      <AccessionDisplay scrollRestorationId="accessions-display-default" />
      <CommandMenuProvider>
        <CommandMenu />
      </CommandMenuProvider>
    </ViewProvider>
  );
};
